<div *ngIf="isLoading">
  <div class="subheader skeleton" style="margin-bottom: 1.25rem; margin-top: 2rem;">
  </div>
  <div class="dorm_list flex column skeleton">
    <div *ngIf="isLoading">
      <app-skeleton-room></app-skeleton-room>
    </div>
  </div>
</div>

<div *ngIf="!isLoading && roomsEmpty()">
  <div class="no-availability-component">
    <div class="no-availability-bubble">
      <div class="icon-container">
        <div class="icon-background">
          <svg-icon
            [svgStyle]="{ 'width.px': 21.5, 'height.px': 21.5 }"
            src="/assets/icons/info.svg"
          ></svg-icon>
        </div>
      </div>
      <div class="no-availability-message">
        <div class="no-availability-subtext">
          Select different dates to see more availability.
        </div>
      </div>
    </div>
  </div>
</div>

<!-- <div class="subheader">
  Dorms
</div>
<div class="empty-room-placeholder">
  <img src="assets/images/empty_room.png" alt="Empty Room" class="empty-room-image"/>
  <img src="assets/images/empty_room.png" alt="Empty Room" class="empty-room-image"/>
</div> -->


<div *ngIf="rooms?.privateRooms?.length">
  <div class="subheader">
    <ng-container i18n>Private Rooms</ng-container>
  </div>
  <div class="dorm_list flex column">
    <app-room *ngFor="let room of rooms.privateRooms;" [room]="room" [hostel]="hostel"></app-room>
  </div>
</div>
<div *ngIf="rooms?.dormRooms?.length">
  <div class="subheader">
    <ng-container i18n>Dorms</ng-container>
  </div>
  <div class="dorm_list flex column">
    <app-room *ngFor="let room of rooms.dormRooms;" [room]="room" [hostel]="hostel"></app-room>
  </div>
</div>
<div *ngIf="rooms?.familyRooms?.length">
  <div class="subheader">
    <ng-container i18n>Family Rooms</ng-container>
  </div>
  <div class="dorm_list flex column">
    <app-room *ngFor="let room of rooms.familyRooms;" [room]="room" [hostel]="hostel"></app-room>
  </div>
</div>
<ng-container *ngIf="showDialog">
  <app-qr-code-dialog (closeDialog)="showDialog = false;"></app-qr-code-dialog>
</ng-container>

